import makeApiRequest from '../../../api/makeApiRequest';

export const NAME = 'questionnaires';

export const STATUS = {
  IDLE: 'idle',
  LOADING: 'loading',
  ERROR: 'error',
  SUCCESS: 'success',
};

const Questionnaires = {
  name: NAME,
  state: {
    questionnaires: {
      groups: [],
      documents: [],
    },
    status: STATUS.IDLE,
  },
  reducers: {
    onLoaded(state, { data: questionnaires }) {
      return { ...state, questionnaires, status: STATUS.SUCCESS };
    },

    onLoading(state) {
      return { ...state, status: STATUS.LOADING };
    },

    onError(state) {
      return { ...state, status: STATUS.ERROR };
    },
  },
  effects: {
    async load(_, { oidcSession }) {
      this.onLoading();
      const [request] = makeApiRequest({ url: '/questionnaires', method: 'get' }, oidcSession);
      const { error, data } = await request;
      if (error) {
        this.onError();
      } else {
        this.onLoaded(data);
      }
    },

    async createSession(payload, { oidcSession }) {
      const body = {
        data: {
          type: 'questionnaire-sessions',
          attributes: payload,
        },
      };

      const [request] = makeApiRequest(
        { url: `/questionnaire-sessions`, method: 'post', data: body },
        oidcSession,
      );

      const { data } = await request;

      return data;
    },
  },
};

export default Questionnaires;
